/**
 * Vencimiento.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import time from '../../../static/img/time.png';

//Services
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class Vencimiento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabledBtn: false,
        }
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    componentWillMount() {
        processIdClientAnalytics('vencimiento');
    }

    render() {
        console.log("url index ", this.props.urlIndex);
        const footer = {
            button: {
                text : "empezar de nuevo",
                disabled : this.state.disabledBtn,
                link: this.props.urlIndex
            }
        };
        const body = {img : {src : time}}
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >Se venció el tiempo</h5>
                            <h5 className="title">para continuar el proceso</h5>
                            <h6 className="description">Por favor, completá los datos<br />
                                nuevamente.</h6>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

export default connect()(Vencimiento);



// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/Vencimiento.js